/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowParallelVIcon24Regular = forwardRef('ArrowParallelVIcon24Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M2.61 9.366a.75.75 0 0 1-1.06-1.06l3.927-3.928a2.156 2.156 0 0 1 3.05 0l3.927 3.928a.75.75 0 1 1-1.06 1.06L7.752 5.725V19.5a.75.75 0 0 1-1.5 0V5.725L2.61 9.366Z" }),
        React.createElement("path", { d: "M17.751 18.28V4.503a.75.75 0 1 0-1.5 0v13.775l-3.641-3.641a.75.75 0 0 0-1.06 1.06l3.927 3.928a2.156 2.156 0 0 0 3.049 0l3.927-3.928a.75.75 0 1 0-1.06-1.06l-3.642 3.641Z" })));
});
